<template>
    <div class="page-content">
        <div class="wrapper">
			<slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "AdminInner"
}
</script>

